/** Newsletter links contain bearer tokens; never put them in analytics or referrers. */
export const isNewsletterPrivatePath = (value: string) => {
  try { return /^\/(?:kundenkonto\/)?newsletter(?:\/|$)/i.test(new URL(value, 'https://shop.invalid').pathname) }
  catch { return false }
}

export const redactNewsletterUrl = (value: string) => {
  if (!isNewsletterPrivatePath(value)) return value
  try {
    const url = new URL(value, 'https://shop.invalid')
    return /^https?:\/\//i.test(value) ? `${url.origin}${url.pathname}` : url.pathname
  } catch { return '/newsletter' }
}
